import { render, staticRenderFns } from "./StrangerThingsHome.vue?vue&type=template&id=5fa35aa7&scoped=true&"
import script from "./StrangerThingsHome.vue?vue&type=script&lang=js&"
export * from "./StrangerThingsHome.vue?vue&type=script&lang=js&"
import style0 from "./StrangerThingsHome.vue?vue&type=style&index=0&id=5fa35aa7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa35aa7",
  null
  
)

export default component.exports